<template>
<div id="home">
  <div class="container-fluid main">
    <router-view></router-view>
  </div>
</div>
</template>

<script>
export default {
  name: 'admin'
}
</script>

<style scoped lang="less">
@import '~variables';
.main {
    padding-bottom: 3rem;
}
</style>
